<template>
  <div class="outbox">
    <FileSee ref='FileSee' :info='info'></FileSee>
    <div class="tp">
      <h3>退费计算</h3>
      <a href="javascript:void(0);" @click="sub"
        v-if="$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit')">确认</a>
      <label>合计</label>
      <b>{{ getFee }}</b>
    </div>
    <a-form-model ref="forms" :model="form" class="forms"
      v-if="$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit')">
      <div class="li" v-for="(i, index) in form.list">
        <div class="cell ">
          <a-form-model-item :label="i.type == 1 ? '已退金额' : (i.type == 2 ? '未退金额' : '不退金额')"
            :prop="'list.' + index + '.fee'" :rules="{ required: false, message: '请填写已退金额', trigger: 'blur' }"
            class="nums" style="width:40%;">
            <input v-model="i.fee" type="number" class="numb" placeholder="请输入"
              :disabled="!$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit') || i.audit"
              :class="{ 'edit': i.audit }" />
          </a-form-model-item>
          <a-form-model-item label="时间" :prop="'list.' + index + '.time'"
            :rules="{ required: false, message: '请选择时间', trigger: 'change' }" style="width:60%;">
            <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss"
              format='YYYY-MM-DD' style="min-width: 140px;"
              :disabled="!$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit')" />
          </a-form-model-item>
        </div>
        <div class="cell fcell">
          <a-form-model-item label="附件" :prop="'list.' + index + '.files'"
            :rules="{ required: false, message: '请选择附件', trigger: 'change' }">
            <div class="files">
              <span @click='see(i.filesobj)'>{{ i.filesobj.origin_name }}</span>
              <div class="rt">
                <div class="see" @click='see(i.filesobj)' v-if='i.filesobj.url'>查看</div>
                <div class="upload">
                  选择文件
                  <input type="file" @change="handlePreview($event, index)" accept="*"
                    :disabled="!$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit')" />
                </div>
              </div>

            </div>
          </a-form-model-item>
        </div>
        <div class="cell fcell">
          <a-form-model-item label="备注" :prop="'list.' + index + '.comment'"
            :rules="{ required: false, message: '请填写备注', trigger: 'blur' }">
            <a-input v-model="i.comment" type="textarea" style="height:96px;"
              :disabled="!$common.AccAUTH($store.state.cause.accuser.id, $store.state.cause.invaild == 1 ? 'return:invaild:edit' : 'return:edit')" />
          </a-form-model-item>
        </div>
      </div>
    </a-form-model>
  </div>
</template>
<script>
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from "@/components/filesee"
import { Filetype } from "@/assets/js/unit"
import $http from "superagent"
import { refundAdd } from '@/server/api'
export default {
  name: 'Out',
  props: {
    Proposition: Array,
    outList: Array
  },
  data() {
    return {
      money: 0,
      info: {},
      form: {
        "list": [

        ]
      }
    }
  },
  components: {
    FileSee
  },
  watch: {
    outList: {
      handler(val) {
        if (val) {
          this.$set(this.form, 'list', val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.money = this.PropMoney()
  },
  computed: {
    getFee() {
      return this.sortMoney(this.form.list)
    }
  },
  methods: {
    handleInput2(e) {
      e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
      const reg = /[^\d.]/g;

      // 只能是数字和小数点，不能是其他输入
      e.target.value = e.target.value.replace(reg, "");

      // 保证第一位只能是数字，不能是点
      e.target.value = e.target.value.replace(/^\./g, "");
      // 小数只能出现1位
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      e.target.value = e.target.value.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
    },
    sortMoney(list) {
      let i = 0
      list.map(ele => {
        i += (parseFloat(ele.fee || 0))
      })
      return i.toFixed(2)
    },
    PropMoney() {
      if (this.Proposition) {
        let i = 0
        this.Proposition.filter(s => { return [8, 9, 4, 5].indexOf(s.type) < 0 }).map(ele => {
          i += ele.fee / 100
        })
        return i.toFixed(2)
      } else {
        return 0
      }
    },
    see(i) {
      // console.log(i)
      if (Filetype(i.url) == 4) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + i.url)
      } else {
        this.info = {
          type: Filetype(i.url),
          url: i.url,
          title: i.title || i.origin_name,
        }
        this.$refs.FileSee.visible = true;
      }
    },
    async handlePreview(file, index) {         //上传图片
      //上传前

      let files = file.target.files
      let form = JSON.parse(JSON.stringify(this.form.list))
      if (files[0].size >= 5 * 1024 * 1024) {
        this.$message.error("上传不能超过5m")
        return false;
      }

      $http.post(Tacitly.Base_Port + "upload/file").set('Authorization', localStorage.getItem("t")).attach('file', files[0]).then((res) => {
        let data = res.body.data;
        if (res.body.code == "0000") {
          form[index].files = data.id
          form[index].filesobj = data
          this.$set(this.form, 'list', form)
          setTimeout(e => {
            this.$refs.forms.clearValidate()
          }, 200)
        } else {
          this.$message.error({ content: res.body.msg, key: 'updatable' });
        }
      })
    },
    sub() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          const all = this.sortMoney(form.list)
          // console.log(all, this.money)
          if (all != this.money) {
            this.$message.error('退费总额与诉讼费用不一致')
            return false
          }
          form.list.map(ele => {
            ele.fee = ele.fee * 100
            delete ele.filesobj
          })
          form.cause_id = this.$store.state.cause.id
          refundAdd(form).then(e => {
            this.$message.success('已提交审核')
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.outbox {
  padding: 0 20px;
  margin-bottom: 20px;

  .tp {
    font-size: 16px;
    color: #0e2949;
    line-height: 22px;
    margin: 22px 0 11px;
    display: flex;
    align-items: center;

    h3 {
      font-weight: bold;
      margin-right: 50px;
      margin-bottom: 0;
      font-size: 16px;
    }

    b {
      font-size: 18px;
    }

    label {
      font-size: 14px;
    }
  }

  a {
    width: 40px;
    line-height: 25px;
    background: #1d8bfe;
    border-radius: 4px;
    display: block;
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-right: 12px;
  }

  .forms {
    display: flex;

    .li {
      background: #f8f9fb;
      padding: 20px;
      flex: 1;
      max-width: 33.3%;
      overflow: hidden;
      margin-right: 20px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .cell {
      display: flex;

      .edit {
        border: 1px solid #ff9800 !important;
      }

      .numb {
        height: 32px;
        border: 1px solid #d9d9d9;
        position: relative;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-indent: 6px;
        background: none;
        width: 100%;
      }

      .files {
        height: 32px;
        border: 1px solid #d9d9d9;
        position: relative;
        border-radius: 4px;
        display: flex;
        align-items: center;

        span {
          max-width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 10px;
          cursor: pointer;
        }

        .rt {
          font-size: 14px;
          color: #1e8bfe;
          line-height: 32px;
          right: 5px;
          position: absolute;
          display: flex;
          top: 0;

          .upload {
            position: relative;
            margin-left: 10px;
          }

          .see {
            cursor: pointer;
          }

          input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        }
      }
    }
  }

  .cell {
    /deep/ .ant-form-item {
      flex: 1;
      display: flex;
      margin-bottom: 12px;
      align-items: center;

      .ant-input,
      .ant-input:hover {
        background: none;
      }

      .has-error {
        position: relative;

        .ant-form-explain {
          position: absolute;
          bottom: -16px;
          font-size: 12px;
        }

        input,
        .files {
          border: 1px solid #f5222d;
        }
      }

      .ant-form-item-label {
        min-width: 80px;
      }
    }

    .nums {
      /deep/ .ant-form-item-control-wrapper {
        .has-error {
          .ant-form-explain {
            bottom: -20px;
          }
        }
      }
    }
  }

  .fcell {
    /deep/ .ant-form-item {
      .ant-form-item-control-wrapper {
        flex: 3;
      }
    }

    &:nth-last-child(1) {
      /deep/ .ant-form-item {
        margin-bottom: 0;
        align-items: flex-start;
      }
    }
  }
}
</style>